module.exports = __webpack_public_path__ + "img/web development.de902072.jpg";